import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AutocompleteModule } from "maps-angular-components";
import { ButtonsModule } from "ngx-bootstrap";
import { CommonModule } from "@angular/common";
import { FuncaoApi } from "./api/funcao.api";
import { FuncaoFacade } from "./funcao.facade";
import { FuncaoModelosModalComponent } from "./containers/funcao-modelos-modal/funcao-modelos-modal.component";
import { FuncaoSelecaoComponent } from "./containers/funcao-selecao/funcao-selecao.component";
import { FuncaoState } from "./state/funcao.state";
import { FuncaoTableComponent } from './components/funcao-table/funcao-table.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { NgModule } from "@angular/core";

@NgModule({
  declarations: [
    FuncaoSelecaoComponent,
    FuncaoModelosModalComponent,
    FuncaoTableComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatDialogModule,
        MatInputModule,
        MatTableModule,
        MatButtonModule,
        ButtonsModule,
        AutocompleteModule,
        MatAutocompleteModule,
        MatProgressBarModule
    ],
    exports: [
      FuncaoSelecaoComponent,
      FuncaoModelosModalComponent
    ],
  providers: [FuncaoApi, FuncaoFacade, FuncaoState],
  entryComponents: [
    FuncaoModelosModalComponent
  ],
})
export class FuncaoModule {}
